<template>
  <v-navigation-drawer dark
                       :width="250"
                       fixed
                       style="z-index: 2"
                       class="fill-height elevation-6 pa-0">
    <v-card color="primary" flat tile max-width="100%" height="100%">
      <v-card-text class="pa-0">
        <v-list class="mt-16">
          <v-list-item class="px-2">
            <v-list-item-avatar>
              <template v-if="role.includes('admin')">
                <v-avatar color="success" size="48" class="d-inline-flex align-center justify-center">
                  <span class="white--text headline text-uppercase">a</span>
                </v-avatar>
              </template>
              <template v-if="role.includes('user')">
                <v-avatar color="success" size="48" class="d-inline-flex align-center justify-center">
                  <span class="white--text headline text-uppercase">u</span>
                </v-avatar>
              </template>
            </v-list-item-avatar>

            <v-list-item-title>{{ user.name }}</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item-group>
            <v-list-item v-for="(item, i) in menu" :key="i"
                         @click="$router.push({name: item.route}).catch( error => {})">
              <v-list-item-icon class="mr-4">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content v-text="$t(item.content)"></v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'SideMenuComponent',
  props: {
    role: null,
    user: null
  },
  computed: {
    menu () {
      if (this.$store.getters.GET_ROLE) {
        return this.$store.getters.GET_ROLE.includes('admin')
          ? this.$t('admin.menu')
          : this.$t('admin.user')
      }
      return []
    }
  }
}
</script>

<style scoped>

</style>
